const types = {
  GET_BOTS: "GET_BOTS",
  SET_BOT_SELECTED: "SET_BOT_SELECTED",
  SET_BOT_THEMES: "SET_BOT_THEMES",
  SET_BOT_IM_MAPPING: "SET_BOT_IM_MAPPING",
  SET_BOT_TOKEN: "SET_BOT_TOKEN",
  SET_BOT_DEPLOYMENT_HANDLER: "SET_BOT_DEPLOYMENT_HANDLER",
  SET_BOT_DEPLOYMENT_VOICE: "SET_BOT_DEPLOYMENT_VOICE",
  SET_SANDBOX_CHAT_BOT: "SET_SANDBOX_CHAT_BOT",
  GET_BOT_BUILDER: "GET_BOT_BUILDER",
  UPDATE_FILTERS_FORM_REPORT: "UPDATE_FILTERS_FORM_REPORT",
  UPDATE_DYNAMIC_FILTERS_REPORT: "UPDATE_DYNAMIC_FILTERS_REPORT",
  UPDATE_DYNAMIC_FILTERS_OPTIONS: "UPDATE_DYNAMIC_FILTERS_OPTIONS",
  UPDATE_SELECTED_REPORT: "UPDATE_SELECTED_REPORT",
  UPDATE_CONVERSATION_HISTORY: "UPDATE_CONVERSATION_HISTORY",
  UPDATE_CONVERSATION_FILTERS: "UPDATE_CONVERSATION_FILTERS",
  SEND_OTP_REQUEST: "SEND_OTP_REQUEST",
  SEND_OTP_SUCCESS: "SEND_OTP_SUCCESS",
  SEND_OTP_FAIL: "SEND_OTP_FAIL",
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAIL: "LOGIN_FAIL",
  ADD_DEALER_DATA: "ADD_DEALER_DATA",
  WORKSHOP_DATA: "WORKSHOP_DATA",
  ERROR_WORKSHOP_DATA: "ERROR_WORKSHOP_DATA",
  ERROR_ADD_DEALER_DATA: "ERROR_ADD_DEALER_DATA",
  RSM_REQUEST: "RSM_REQUEST",
  RSM_SUCCESS: "RSM_SUCCESS",
  RSM_FAIL: "RSM_FAIL",
  RSM_PHOTO_SUCCESS: "RSM_PHOTO_SUCCESS",
  RSM_PHOTO_FAIL: "RSM_PHOTO_FAIL",
  RSM_DEALER_ID_SUCCESS: "RSM_DEALER_ID_SUCCESS",
  RSM_DEALER_ID_FAIL: "RSM_DEALER_ID_FAIL",
  RSM_DEALER_PAN_SUCCESS: "RSM_DEALER_PAN_SUCCESS",
  RSM_DEALER_PAN_FAIL: "RSM_DEALER_PAN_FAIL",
  RSM_APPROVED: "RSM_APPROVED",
  RSM_APPROVED_FAIL: "RSM_APPROVED_FAIL",
};

export default types;
